import React from "react";
import { connect } from "react-redux";
import { ReCaptchaProvider } from "@wss/re-captcha";
import { Product, SelectedProduct } from "~/common/Store/models/ProductListing";
import {
  RootState,
  UserState,
  ChatState,
} from "~/common/Store/models/RootReadonly";
import StandardPrice from "../Price";
import A from "./A";
import B from "./B";
import C from "./C";
import D from "./D";
import E from "./E";
import F from "./F";
import G from "./G";
import H from "./H";
import I from "./I";
import J from "./J";
import K from "./K";
import L from "./L";
import M from "./M";
import N from "./N";
import O from "./O";
import P from "./P";
import Q from "./Q";
import S from "./S";
import T from "./T";
import U from "./U";
import V from "./V";
import W from "./W";
import X from "./X";
import Y from "./Y";
import Z from "./Z";
import { User } from "~/common/Store/models/User";
import Registered from "./Registered";
import { Chat } from "~/common/Store/models/Chat";

export interface VariantProps {
  price: Product["price"];
  unitOfMeasure: string;
  user: User;
  mapPrice: number;
  type: string;
  itemNumber: string;
  product: Product;
  selectedProduct: SelectedProduct;
  chat: Chat;
  productListingView?: string;
  displayOutletCallForPricing?: boolean;
  setIsQuantityDiscountPopoverOpen?: React.Dispatch<
    React.SetStateAction<string>
  >;
}

const MapVariants: { [key: string]: (props: VariantProps) => JSX.Element } = {
  A,
  B,
  C,
  D,
  E,
  F,
  G,
  H,
  I,
  J,
  K,
  L,
  M,
  N,
  O,
  P,
  Q,
  S,
  T,
  U,
  V,
  W,
  X,
  Y,
  Z,
};

interface Props {
  price: Product["price"];
  unitOfMeasure: string;
  itemNumber: string;
  mounted: boolean;
  user: UserState;
  showBelowMinimumAdvertisedPriceForLoggedInCustomers: boolean;
  showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers: boolean;
  product: Product;
  selectedProduct: SelectedProduct;
  chat: ChatState;
  productListingView?: string;
  setIsQuantityDiscountPopoverOpen?: React.Dispatch<
    React.SetStateAction<string>
  >;
  displayOutletCallForPricing: boolean;
}

const Map = ({
  price,
  unitOfMeasure,
  itemNumber,
  user,
  price: {
    minimumAdvertisedPriceProperties: { type, price: mapPrice },
  },
  product,
  selectedProduct,
  chat,
  productListingView,
  setIsQuantityDiscountPopoverOpen,
  displayOutletCallForPricing,
}: Props) => {
  const variantProps = {
    unitOfMeasure,
    price,
    itemNumber,
    user,
    mapPrice,
    type,
    product,
    selectedProduct,
    chat,
    productListingView,
    displayOutletCallForPricing,
  };

  const showRegistered =
    user.registered &&
    (selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers ||
      (selectedProduct.showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers &&
        (user.hasWebPlus || (user.platinum && user.platinum.enabled)))) &&
    !displayOutletCallForPricing;

  // Map L, Y and J still show Custom Quote but have additional requirements for qualification and handled in Map files
  const mapStylesDoesNotDisplayCustomQuoteText = ["L", "J", "Y"];

  if (
    showRegistered &&
    !mapStylesDoesNotDisplayCustomQuoteText.includes(type)
  ) {
    return (
      <>
        <Registered
          {...{
            user,
            selectedProduct,
            productListingView,
            setIsQuantityDiscountPopoverOpen,
          }}
        />
      </>
    );
  }

  const MapVariant = MapVariants[displayOutletCallForPricing ? "P" : type];

  if (MapVariant)
    return (
      <ReCaptchaProvider>
        <MapVariant {...variantProps} />
      </ReCaptchaProvider>
    );

  return (
    <div className="map map-override">
      <StandardPrice price={price.price} unitOfMeasure={unitOfMeasure} />
    </div>
  );
};

export const mapStateToProps = (state: RootState, ownProps: Props) => {
  if (!ownProps.mounted) return { user: ownProps.user, char: ownProps.chat };
  return state;
};

export default connect(mapStateToProps)(Map);
